import React, { useEffect, useState, useContext } from 'react';
import CardMarketRent from './CardMarketRent/CardMarketRent';
import CardLeaseAgreements from './CardLeaseAgreements/CardLeaseAgreements';
import CardTotalUnits from './CardTotalUnits/CardTotalUnits';
import { TaskContext } from '../DscrQuestionsAgreements';
import { Task, TaskResponse } from 'gql/graphql';
import { useGetTaskResponsesByTask } from 'services/task/querys';
import CardBorrowerImpersonation from '../../../CardBorrowerImpersonation/CardBorrowerImpersonation';
import SectionIssues from '../../../SectionIssues/SectionIssues';

interface Step3Props {
  task: Task | any;
}

const Step3 = ({ task }: Step3Props) => {
  // @ts-ignore
  const { totalUnits, setTotalUnits, vacantUnits, setVacantUnits, occupiedUnits } = useContext(TaskContext);
  const [response1, setResponse1] = useState<TaskResponse | any>();
  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } },
    pause: true
  });

  useEffect(() => {
    getTaskResponses({ requestPolicy: 'network-only' });
  }, [])

  useEffect(() => {
    if(taskResponses) {
      const step3Response_totalUnits = taskResponses.find((item) => item.key === 'units-in-property-dscr-step3') as TaskResponse;
      const step3Response_vacantUnits = taskResponses.find((item) => item.key === 'market-rent') as TaskResponse;
      const step3Response_leaseAgreements = taskResponses.find((item) => item.key === 'lease-agreements') as TaskResponse;
      setResponse1(step3Response_totalUnits);
      if (step3Response_totalUnits && !step3Response_totalUnits && !step3Response_vacantUnits && !step3Response_leaseAgreements) {
        setTotalUnits(response1.metadata.totalUnits);
        // setVacantUnits(lastStep2Response.metadata.vacantUnits);
      } else if (step3Response_totalUnits && step3Response_vacantUnits) {
        setTotalUnits(step3Response_totalUnits.metadata.totalUnits);
        setVacantUnits(step3Response_vacantUnits.metadata.vacantUnits);
      }
    }
  }, [taskResponses]);

  const taskHasResponses = taskResponses && taskResponses.length > 0;

  return (
    <section className="Step3">
      <h2 className="h2">
        Give us market rents for the{' '}
        <span className="blue-bold">{vacantUnits} vacant units</span> and lease agreements
        for the <span className="blue-bold">{occupiedUnits} occupied units</span> in the
        property
      </h2>
      <p className="h4 h4-w4">
        We’ll review the leases and calculate your final DSCR for you
      </p>
      <CardBorrowerImpersonation hasResponses={taskHasResponses} />
      <SectionIssues task={task}/>
      <div className="mt-25">
        <CardTotalUnits
          totalUnits={totalUnits}
        />
      </div>
      <div className="mt-25">
        <CardMarketRent 
          vacantUnits={vacantUnits} 
          task={task}
          />
      </div>
      <div className="mt-25">
        <CardLeaseAgreements
          ammountFiles={occupiedUnits}
          task={task}
        />
      </div>
    </section>
  );
};
export default Step3;
